// betaApplicationManagment
//
// Candidatures de bêta-testeur déposées depuis le formulaire public (site Betatest) et
// examinées ici par le super-admin. Une candidature acceptée crée le compte créateur.

export type BetaApplicationStatus = 'pending' | 'accepted' | 'refused' | 'waitlist';

export const BETA_APPLICATION_STATUS_VALUES : BetaApplicationStatus[] = [ 'pending' , 'waitlist' , 'accepted' , 'refused' ];

export const BETA_APPLICATION_STATUS_LABELS : Record<BetaApplicationStatus, string> = {
  pending  : 'En attente'         ,
  waitlist : 'Liste d\'attente'   ,
  accepted : 'Acceptée'           ,
  refused  : 'Refusée'            ,
};

export const BETA_AGE_RANGE_LABELS : Record<string, string> = {
  '15-18' : '15-18 ans (validation parentale requise)' ,
  '19-25' : '19-25 ans' ,
  '26-35' : '26-35 ans' ,
  '36-45' : '36-45 ans' ,
  '46-55' : '46-55 ans' ,
  '56-65' : '56-65 ans' ,
  '66+'   : 'Plus de 65 ans' ,
};

export const BETA_ACTIVITY_LABELS : Record<string, string> = {
  createur         : 'Créateur' ,
  media_local      : 'Média local' ,
  association_club : 'Association / Club sportif' ,
  ecole            : 'École' ,
  artiste          : 'Artiste' ,
  entreprise       : 'Entreprise' ,
  autre            : 'Autre' ,
};

export const BETA_EQUIPMENT_LABELS : Record<string, string> = {
  desktop    : 'Ordinateur de bureau' ,
  laptop     : 'Ordinateur portable' ,
  tablet     : 'Tablette' ,
  smartphone : 'Smartphone' ,
};

export const BETA_OPERATING_SYSTEM_LABELS : Record<string, string> = {
  apple      : 'Apple' ,
  linux_unix : 'Linux / Unix' ,
  windows    : 'Windows' ,
  android    : 'Android' ,
  other      : 'Autre' ,
};

export interface BetaApplicationEquipment {
  model            : string | null;
  operatingSystems : string[];
}

export interface BetaApplication {
  id                : number;
  firstname         : string;
  lastname          : string;
  email             : string;
  phoneNumber       : string;
  ageRange          : string;
  activity          : string;
  activityOther     : string;
  organization      : string;
  website           : string;
  // Nom public choisi à la candidature (futur pseudonyme du créateur) ; vide pour les candidatures anciennes
  publicName        : string;
  description       : string;
  equipments        : Record<string, BetaApplicationEquipment>;
  cguAcceptedDate   : Date | null;
  // Adresse confirmée par le clic sur le lien du mail de vérification (jeton jamais renvoyé)
  emailValidated    : boolean;
  // Candidature d'une personne qui a déjà un compte client : l'acceptation PROMEUT ce compte
  // (mot de passe conservé, aucun mail de vérification) au lieu d'en créer un.
  isPromotion       : boolean;
  existingUserId    : number | null;
  emailValidationDate : Date | null;
  status            : BetaApplicationStatus;
  creationDate      : Date | null;
  reviewedDate      : Date | null;
  reviewedByAdminId : number | null;
  createdAdminId    : number | null;
  ipAddress         : string;
}

// Libellé de l'activité, avec la précision libre quand elle vaut « autre »
export const getBetaActivityLabel = ( application: BetaApplication ): string => {

  const label = BETA_ACTIVITY_LABELS[application.activity] ?? application.activity;

  return application.activity === 'autre' && application.activityOther !== ''
           ? `${label} — ${application.activityOther}`
           : label;
};
